import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "../api/auth";

export default function BillingSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkPlan = async () => {
      try {
        const res = await getMe();

        if (
          res.data.user.subscription?.status ===
          "active"
        ) {
          navigate("/dashboard");
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkPlan();
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h1>🎉 Payment Successful</h1>

      <p>
        Activating your subscription...
      </p>
    </div>
  );
}